// extracted by extract-css-chunks-webpack-plugin
module.exports = {"expenseCalculatorComp":"_2dWyut","results":"_3_d7w8","label":"_2nM3bE","row":"_12j9wq","rowRight":"_255bDj","infoBtn":"_3kygk0","statusIcon":"_2v_jGE"};